import React from 'react';
import Title from '../../../../../@casino/ui/title';
import {useFormik, FormikContext} from "formik";
import { useDispatch, useSelector } from 'react-redux';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import {useRouter} from '../../../../../@casino/useRouter';
import { setGetByIdLottery } from '../../store/thunk/setGetByIdLottery';
import { setPostUpdateLottery } from '../../store/thunk/setPostUpdateLottery';

const useStyles = makeStyles(() => ({
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    wrapLabel: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
    },
    nameBonusLabel: {
        width: 420,
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
    },
    games_item: {
        cursor: 'pointer',
        textTransform: 'capitalize',
        '&:hover': {
            background: '#4c5e91',
        }
        
    }
}))

const getDateForm = (event_date) => {
    const day = new Date(+event_date).getDate() < 10 ? '0' + new Date(+event_date).getDate() : new Date(+event_date).getDate();
    const month = +new Date(+event_date).getMonth() + 1 < 10? '0' + (+new Date(+event_date).getMonth() + 1) : new Date(+event_date).getMonth() + 1;
    const year = new Date(+event_date).getFullYear();
    
    return `${year}-${month}-${day}`
}

const LotteryEdit = () => {
    const classes = useStyles()
    const dispatch = useDispatch();
    const router = useRouter();
    const {id} = router.match.params;
 
    React.useEffect(() => {
        dispatch(setGetByIdLottery({id}))
    }, [id]);

    const onSubmit = (store) => {
        dispatch(setPostUpdateLottery(store));
        router.history.push('/lottery/list')
    }

    const initialValues = useSelector(state => state.lottery.view)

    const enableReinitialize = true;
    const formik = useFormik({onSubmit, initialValues, enableReinitialize});

    const getValidation = (values) => {
        if (!!!values?.label_name || !!!values?.description || isNaN(values?.start) || isNaN(values?.end) || Number(values?.fund) === 0) {
            return false;
        }

        return true;
    }

    return (
        <div style={{padding: 20, paddingTop: 0, height: '100%', overflow: 'scroll'}}>
            <Title label="Редактирование лотереии" />
            <div style={{
                padding: 20,
                background: '#1b2039',
                borderRadius: 8,
                marginBottom: 12,
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                 <span style={{
                    padding: 10, 
                    background: '#ffc324', 
                    borderRadius: 4, 
                    cursor: 'pointer', 
                    color: '#141b33',
                    userSelect: 'none'
                }}
                    onClick={() => {
                        router.history.push('/lottery/list')
                    }}
                >Назад</span>
                <div style={{paddingTop: 10}}>
                    <span style={{
                        padding: 10, 
                        background: '#34eb46', 
                        borderRadius: 4, 
                        cursor: 'pointer', 
                        color: 'rgb(20, 27, 51)',
                        userSelect: 'none',
                        marginRight: 12
                    }}
                        onClick={() => {
                            router.history.push(`/lottery/stat/${id}`)
                        }}
                    >Статистика</span>
                    <span style={{
                        padding: 10, 
                        background: getValidation(formik.values) ? '#ffc324' : '#eee', 
                        borderRadius: 4, 
                        cursor: getValidation(formik.values) ? 'pointer' : 'default', 
                        color: '#141b33',
                        userSelect: 'none'
                    }}
                        onClick={() => {
                            if (getValidation(formik.values)) {
                                formik.submitForm()
                            }   
                        }}
                    >Сохранить</span>
                </div>
            </div>
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
                marginBottom: 12,            
            }}>
                <FormikContext.Provider value={formik}>
                    <form onSubmit={formik.handleSubmit}>
                        <div>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <label htmlFor="label_name" className={clsx(classes.wrapLabel, classes.nameBonusLabel)} style={{marginRight: 12, marginBottom: 0}}>
                                    <span className={classes.helper}>Название лотереии</span>
                                    <input 
                                        type="text" 
                                        name="label_name" 
                                        id="label_name" 
                                        placeholder="Название"
                                        className={classes.text} 
                                        value={formik.values.label_name} 
                                        onChange={(v) => formik.setFieldValue('label_name', v.target.value)}
                                    />
                                </label>  
                                <label htmlFor="start" className={clsx(classes.wrapLabel, classes.beginBonusLabel)} style={{marginRight: 12}}>
                                    <span className={classes.helper}>Начало Лотереии</span>
                                    <input 
                                        type="date" 
                                        name="start" 
                                        id="start" 
                                        className={classes.text}
                                        value={getDateForm(formik.values.start)} 
                                        onChange={(v) => formik.setFieldValue('start', new Date(v.target.value).getTime())}
                                    />
                                </label>
                                <label htmlFor="end" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                    <span className={classes.helper}>Конец Лотереии</span>
                                    <input 
                                        type="date" 
                                        name="end" 
                                        id="end" 
                                        className={classes.text}
                                        value={getDateForm(formik.values.end)} 
                                        onChange={(v) => formik.setFieldValue('end', new Date(v.target.value).getTime())}
                                    />
                                </label>
                            </div>
                            
                            <label htmlFor="description" className={clsx(classes.wrapLabel, classes.nameBonusLabel)}>
                                <span className={classes.helper}>Описание лотереии</span>
                                <textarea style={{
                                    borderRadius: '4px',
                                    height: '150px',
                                    maxWidth: '800px',
                                    width: '100%',
                                    overflow: 'hidden',
                                    boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
                                    border: 0,
                                    background: '#1c2542',
                                    color: '#fff',
                                    outline: 'none',
                                    paddingLeft: 8,
                                    resize: 'none'
                                }}
                                    placeholder="Описание"
                                    value={formik.values.description}
                                    onChange={(v) => formik.setFieldValue('description', v.target.value)}
                                >

                                </textarea>
                            </label> 
                        </div>
                        <div style={{
                            marginTop: 24,
                            marginBottom: 12,
                            width: '100%',
                            height: '1px',
                            background: '#1c2542',
                            boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)'
                        }}>

                        </div>

                        <div>
                            <div style={{display: 'flex'}}>
                                <label htmlFor="price_ticket_deposit" className={clsx(classes.wrapLabel, classes.nameBonusLabel)} style={{marginRight: 12, marginBottom: 0}}>
                                    <span className={classes.helper}>Цена билета от депозита</span>
                                    <input 
                                        type="text" 
                                        name="price_ticket_deposit" 
                                        id="price_ticket_deposit" 
                                        className={classes.text} 
                                        value={formik.values.price_ticket_deposit} 
                                        onChange={(v) => {
                                            if (!(isNaN(+v.target.value))) {
                                                formik.setFieldValue('price_ticket_deposit', v.target.value)
                                            }
                                           
                                        }}
                                    />
                                </label> 
                                <label htmlFor="price_ticket" className={clsx(classes.wrapLabel, classes.nameBonusLabel)} style={{marginRight: 12, marginBottom: 0}}>
                                    <span className={classes.helper}>Цена билета</span>
                                    <input 
                                        type="text" 
                                        name="price_ticket" 
                                        id="price_ticket" 
                                        className={classes.text} 
                                        value={formik.values.price_ticket} 
                                        onChange={(v) => {
                                            if (!(isNaN(+v.target.value))) {
                                                formik.setFieldValue('price_ticket', v.target.value)
                                            }
                                           
                                        }}
                                    />
                                </label> 
                                <label htmlFor="gold_ticket" className={clsx(classes.wrapLabel, classes.nameBonusLabel)} style={{marginRight: 12, marginBottom: 0}}>
                                    <span className={classes.helper}>Цена золотого билета</span>
                                    <input 
                                        type="text" 
                                        name="gold_ticket" 
                                        id="gold_ticket" 
                                        className={classes.text} 
                                        value={formik.values.gold_ticket} 
                                        onChange={(v) => {
                                            if (!(isNaN(+v.target.value))) {
                                                formik.setFieldValue('gold_ticket', v.target.value)
                                            }
                                           
                                        }}
                                    />
                                </label>    
                            </div>
                        </div>

                        <div style={{
                            marginTop: 24,
                            marginBottom: 12,
                            width: '100%',
                            height: '1px',
                            background: '#1c2542',
                            boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)'
                        }}>

                        </div>
                        <div>
                            <div style={{display: 'flex'}}>
                                <label htmlFor="fund" className={clsx(classes.wrapLabel, classes.nameBonusLabel)} style={{marginRight: 12, marginBottom: 0}}>
                                    <span className={classes.helper}>Призовой фонд</span>
                                    <input 
                                        type="text" 
                                        name="fund" 
                                        id="fund" 
                                        className={classes.text} 
                                        value={formik.values.fund} 
                                        onChange={(v) => {
                                            if (!(isNaN(+v.target.value))) {
                                                formik.setFieldValue('fund', v.target.value)
                                            }
                                           
                                        }}
                                    />
                                </label> 
                                <label htmlFor="count_winners" className={clsx(classes.wrapLabel, classes.nameBonusLabel)} style={{marginRight: 12, marginBottom: 0}}>
                                    <span className={classes.helper}>Количество победителей</span>
                                    <input 
                                        type="text" 
                                        name="count_winners" 
                                        id="count_winners" 
                                        className={classes.text} 
                                        value={formik.values.count_winners} 
                                        onChange={(v) => {
                                            if (!(isNaN(+v.target.value))) {
                                                formik.setFieldValue('count_winners', v.target.value);
                                                const winners = [];
                                                for (let i = 0; i < +v.target.value; i++) {
                                                    winners.push(0);
                                                }

                                                formik.setFieldValue('winners', winners);
                                            }
                                        }}
                                    />
                                </label>    
                            </div>
                        </div>

                        <div style={{
                            marginTop: 24,
                            marginBottom: 12,
                            width: '100%',
                            height: '1px',
                            background: '#1c2542',
                            boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)'
                        }}>

                        </div>

                        <div style={{display: 'flex', flexWrap: 'wrap', columnGap: 10, rowGap: 5}}>


                            {
                                formik.values.winners.map((item, key) => (
                                    <label htmlFor="fund" className={clsx(classes.wrapLabel, classes.nameBonusLabel)} style={{marginRight: 12, marginBottom: 0, width: 100}}>
                                        <span className={classes.helper}>{key + 1} Место</span>
                                        <input 
                                            type="text" 
                                            name="fund" 
                                            id="fund" 
                                            className={classes.text}
                                            style={{width: 100}} 
                                            value={formik.values.winners[key]} 
                                            onChange={(v) => {
                                                if (!(isNaN(+v.target.value))) {
                                                    formik.setFieldValue(`winners[${key}]`, +v.target.value)
                                                }
                                            }}
                                        />
                                    </label> 
                                ))
                            }

                            
                        </div>

                        
                            
                    </form>
                </FormikContext.Provider> 
            </div>
        </div>
    )
}

export default LotteryEdit;